<div class="p-field" 
[ngStyle]="{ width: (getLocale().hourFormat === 12 ? '26rem': '24rem')  }">
    <label *ngIf="dateField" for="{{dateId}}">{{dateField}}</label>
    <p-calendar #calend [(ngModel)]="dateModel" [selectionMode]="range ? 'range' : 'single'" [showIcon]="true"
        [monthNavigator]="true" [yearNavigator]="true" [showTime]="showTime"
        yearRange="2000:2030" [readonlyInput]="readOnly" [inputId]="dateId"
        [minDate]="minDate" [maxDate]="maxDate" [dateFormat]="getLocale().dateFormat"
        [hourFormat]="getLocale().hourFormat" [showButtonBar]="showBar"></p-calendar>

</div>